import { render, staticRenderFns } from "./TreeviewsSettingsList.vue?vue&type=template&id=073eb206&"
import script from "./TreeviewsSettingsList.vue?vue&type=script&lang=js&"
export * from "./TreeviewsSettingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports